import { PageHeading } from "@via/components/page-heading.tsx";
import { ADMIN_PROFILE_TABS, PAGE_NAMES } from "@via/utils/constants.tsx";
import { type JSX } from "react";
import { HorizontalTabs } from "@via/components/tabs.tsx";
import { Outlet } from "react-router-dom";

export default function AdminPanel(): JSX.Element {
  return (
    <main className="via-content-wrapper">
      <div className="flex flex-wrap justify-between">
        <PageHeading title={PAGE_NAMES.ADMIN} />
        <HorizontalTabs
          buttonIdPrefix="feature flags"
          options={ADMIN_PROFILE_TABS}
        />
        <main className="py-6 w-full">
          <Outlet />
        </main>
      </div>
    </main>
  );
}
